import React, { useState } from 'react';
import { MenuItem } from './MenuItem';
import styles from './Navigation.module.css';
import { useNavigationQuery } from './category/ApiRequests';

export const Navigation = () => {
    const query = useNavigationQuery();

    const [hasBodyOverlay, setHasBodyOverlay] = useState(false);

    if (query.isLoading) {
        return <span>Loading...</span>
    }

    if (query.isError) {
        return <span>Error: {query.error.message}</span>
    }

    return (
        <nav className={styles.menu}>
            <ul>
                {
                    query.data.map((menuItem) => {
                        return (
                            <li
                                onMouseEnter={() => { setHasBodyOverlay(true); }}
                                onMouseLeave={() => { setHasBodyOverlay(false); }}
                                key={menuItem.id}>
                                <MenuItem categories={menuItem.categories} name={menuItem.name} id={menuItem.id}  />
                            </li>
                        );
                    })
                }
            </ul>
            {hasBodyOverlay && <div className={styles.bodyOverlay} />}
        </nav>
    );
}
